import React from 'react';
import { Box, Typography } from '@mui/material';
import { ActionableItem } from '../../types';
import MoveBackToPrimaryBody from './MoveBackToPrimaryBody';
import AccessRequestBody from './AccessRequestBody';

// One entry per rule that has a custom card body. A rule without an entry falls back to a plain
// key/value list of its payload, so a new rule is usable on day one and can get a nicer body later.
const GenericBody: React.FC<{ item: ActionableItem }> = ({ item }) => (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 1 }}>
        {Object.entries(item.payload || {}).filter(([, v]) => typeof v !== 'object').map(([k, v]) => (
            <Box key={k}>
                <Typography sx={{ fontSize: '0.62rem', fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8A8078' }}>{k.replace(/([A-Z])/g, ' $1')}</Typography>
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>{String(v)}</Typography>
            </Box>
        ))}
    </Box>
);

const RENDERERS: Record<string, React.FC<{ item: ActionableItem }>> = {
    move_back_to_primary: MoveBackToPrimaryBody,
    pending_access_request: AccessRequestBody,
};

export const ActionableBody: React.FC<{ item: ActionableItem }> = ({ item }) => {
    const Body = RENDERERS[item.ruleKey] || GenericBody;
    return <Body item={item} />;
};
